"use strict";
/**
* AppActiveData.ts
* Author: CALIB http://aka.ms/CALIB
* Copyright: Microsoft 2017
*
* Holder for App Active (foreground/background) information
*/
Object.defineProperty(exports, "__esModule", { value: true });
var SyncTasks = require("synctasks");
var AppActiveData = /** @class */ (function () {
    function AppActiveData() {
        this._isActive = false;
    }
    AppActiveData.prototype.putAppActive = function (isActive) {
        this._isActive = isActive;
        if (this.isAppActive() && this._appActiveDeferral) {
            var deferral = this._appActiveDeferral;
            this._appActiveDeferral = undefined;
            deferral.resolve(void 0);
        }
    };
    AppActiveData.prototype.isAppActive = function () {
        return this._isActive;
    };
    AppActiveData.prototype.waitForAppActive = function () {
        if (this.isAppActive()) {
            return SyncTasks.Resolved();
        }
        // Set up deferral to wait for app to become active
        if (!this._appActiveDeferral) {
            this._appActiveDeferral = SyncTasks.Defer();
        }
        return this._appActiveDeferral.promise();
    };
    return AppActiveData;
}());
exports.default = AppActiveData;
